import React from "react";

const Navbar = () => {
    return (
        <nav className="ps-4 navbar navbar-light">
            <a href="/" className="navbar navbar-brand">R'n'R Bands App</a>
        </nav>
    )
}

export default Navbar;